import {Component, Input, OnInit} from '@angular/core';
import {Information} from "../information";

@Component({
  selector: 'app-information-network',
  templateUrl: './information-network.component.html',
  styleUrls: ['./information-network.component.css']
})
export class InformationNetworkComponent  {
  @Input() information: Information;

  constructor() {
    this.information = new Information();
  }

}
